import React, { useEffect, useState } from 'react';
import { ContextData } from '../../../../context/Context';
import { Getrequest } from '../../../../context/AxiosRequest';
import PersonIcon from '@mui/icons-material/Person';

   


    

const ViewRejectMsg = ({applicant_token,document_token}) => {


    const { accesstoken } = React.useContext(ContextData);
    const [Data,setData] = useState([])

    
  useEffect(()=>{

         
      async function fetchData() {
          
                        const response = await Getrequest(`/auth/get_reject_mssg_applicant_doc/${applicant_token}/${document_token}`,accesstoken);
                        setData(response)


                        } fetchData();


  }, []);






    return (
        <div className='font-mono'>

            {

              Data.length > 0 ?
              Data.map((item,index)=>(

                 <div key={index} className='border-solid border-[1px] border-gray-300 rounded-md p-3 mb-3  text-white flex flex-col justify-center items-start'>
                       
                       {
                        item.mssg ?
                       <div className='bg-gray-200 text-black rounded-md px-2 py-1 mb-2'>
                          <p className='flex justify-center items-center'><strong>From Verifier</strong><PersonIcon fontSize="medium" /></p>
                      <p className='p-3'>{item.mssg}</p>
                      <p>Date: <small>{item.insertdate}</small></p>
                       </div>
                       :
                       <p className='text-black'>No Message</p>
                       }
                    
                </div>
              ))
              :

              <div> 
                
                  <h3>No Message</h3>
                 </div>
            }
            
        </div>
    );









}

export default ViewRejectMsg;
